module.exports = __webpack_public_path__ + "static/media/pendon-virgen-coromoto-4-small.d9df7287.jpg";